module.exports = __webpack_public_path__ + "img/x.16feb15a.svg";